var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ErrorIcon from '@mui/icons-material/Error';
import { ERoleTypes, ETeam, getRoleNightActionColor, getRoleNightActionName, getRoleString, } from '../../../../types';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { computeNightResults, wakeUpRole } from '../../../../api';
import { Delimiter } from '../../../atoms/Delimiter';
import { ModalNew } from '../../../atoms/Modal/Modal';
import { DeskPool } from '../../DeskPool';
import { UnderLine } from '../../../atoms/UnderLine';
const nightActionsStyles = {
    padding: '48px 40px',
    alignItems: 'flex-start',
    minWidth: '550px',
    height: '100%',
    display: 'block',
    margin: '0 auto',
};
const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const Container = styled.div `
  display: flex;
  align-items: center;
`;
const ActionsContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const ButtonContainer = styled.div `
  display: flex;
  justify-content: center;
  width: 100%;
`;
const Title = styled.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
`;
const PlayerImg = styled.img `
  width: 40px;
  height: 40px;
  user-select: none;
  border-radius: 50%;
  object-fit: cover;
`;
const ActionText = styled.div `
  display: flex;
  font-size: 14px;
  line-height: 20px;
  color: #fff;

  span {
    font-weight: 700;
    color: ${({ textColor }) => textColor || '#899295'};
  }
`;
const WasPerformedText = styled.div `
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 3px;
  align-self: flex-start;
`;
export function SelectRoleToWakeUp() {
    var _a, _b;
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const roles = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.roles) || [];
    const actions = ((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.actions) || [];
    const matchId = (matchState === null || matchState === void 0 ? void 0 : matchState.id) || '';
    const mafiaRoles = roles.filter((r) => r.team === ETeam.MAFIA);
    const civilianRoles = roles.filter((r) => r.team === ETeam.CIVILIANS);
    const hasActiveRole = roles.find((r) => !r.wasPerformed && r.isPresented && r.canWakeUp && !r.isOptional) !== undefined;
    const onRoleWakeUp = (role) => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield wakeUpRole(role.role, matchId);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
        }
    });
    const changePhase = (id) => __awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield computeNightResults(id);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
        }
    });
    const getPlayerName = (playerId) => {
        const target = matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
        return `${target === null || target === void 0 ? void 0 : target.player.gameName} (${getRoleString((target === null || target === void 0 ? void 0 : target.role) || ERoleTypes.CIVILIAN)})`;
    };
    const getButton = (role) => {
        if (role.wasDisabledByDon) {
            return (_jsx(Button, Object.assign({ className: "wakeUpButton", disabled: true }, { children: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" })));
        }
        if (!role.isPresented) {
            return (_jsx(Button, Object.assign({ className: "wakeUpButton", disabled: true }, { children: "\u041D\u0435\u0442 \u0432 \u0438\u0433\u0440\u0435" })));
        }
        if (!role.canWakeUp) {
            return (_jsx(Button, Object.assign({ className: "wakeUpButton", disabled: true }, { children: "\u041D\u0435 \u043F\u0440\u043E\u0441\u044B\u043F\u0430\u0435\u0442\u0441\u044F \u043D\u043E\u0447\u044C\u044E" })));
        }
        if (role.wasPerformed) {
            if (role.isOptional && role.actionsLeft != null && role.actionsLeft > 0) {
                return (_jsxs(Button, Object.assign({ className: "wakeUpButton", disabled: true }, { children: ["\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C: ", role.actionsLeft] })));
            }
            return (_jsx(Button, Object.assign({ className: "wakeUpButton", disabled: true }, { children: "\u0423\u0436\u0435 \u043F\u0440\u043E\u0441\u044B\u043F\u0430\u043B\u0441\u044F" })));
        }
        return (_jsx(Button, Object.assign({ className: "wakeUpButton", onClick: () => onRoleWakeUp(role) }, { children: role.isOptional && role.actionsLeft != null ? `Разбудить (${role.actionsLeft})` : 'Разбудить' })));
    };
    // eslint-disable-next-line react/no-unstable-nested-components
    function NightActionsInfoModal({ onFouls }) {
        return (_jsx(ModalNew, Object.assign({ onClose: () => null }, { children: _jsxs(Paper, Object.assign({ sx: nightActionsStyles }, { children: [_jsxs(Wrapper, { children: [_jsxs(Typography, Object.assign({ variant: "h2" }, { children: ["\u041D\u043E\u0447\u044C \u2116", (matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) || 1] })), _jsx(Button, Object.assign({ className: "fouls", size: "medium", startIcon: _jsx(ErrorIcon, {}), onClick: () => onFouls === null || onFouls === void 0 ? void 0 : onFouls() }, { children: "\u0424\u043E\u043B\u044B" }))] }), _jsx(Delimiter, { top: "25px" }), roles.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u041C\u0430\u0444\u0438\u044F" })), _jsx(Delimiter, { top: "4px" }), mafiaRoles === null || mafiaRoles === void 0 ? void 0 : mafiaRoles.map((role) => (_jsxs(_Fragment, { children: [_jsx(Delimiter, { top: "12px" }), _jsxs(Wrapper, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: getRoleString(role.role) })), getButton(role)] }, role.role), actions === null || actions === void 0 ? void 0 : actions.map((action) => action.role === role.role && (_jsxs(ActionsContainer, { children: [_jsx(Delimiter, { top: "10px" }), _jsx(Container, { children: _jsxs(ActionText, Object.assign({ textColor: getRoleNightActionColor(action.role) }, { children: [_jsxs("span", { children: [getRoleNightActionName(action.role), ":"] }), _jsx(Delimiter, { right: "8px" }), getPlayerName(action.targetId)] })) }), _jsx(Delimiter, { top: "24px" }), _jsx(UnderLine, { theme: { borderColor: '#517573' } })] }, action.role)))] }))), _jsx(Delimiter, { top: "34px" }), _jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0413\u043E\u0440\u043E\u0434" })), _jsx(Delimiter, { top: "4px" }), civilianRoles === null || civilianRoles === void 0 ? void 0 : civilianRoles.map((role) => {
                                var _a;
                                return (_jsxs(_Fragment, { children: [_jsx(Delimiter, { top: "12px" }), _jsxs(Wrapper, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: getRoleString(role.role) })), _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: (_a = role.players[0]) === null || _a === void 0 ? void 0 : _a.player.gameName })), getButton(role)] }, role.role), actions === null || actions === void 0 ? void 0 : actions.map((action) => action.role === role.role && (_jsxs(ActionsContainer, { children: [_jsx(Delimiter, { top: "10px" }), _jsxs(Container, { children: [_jsx(Delimiter, { right: "48px" }), _jsxs(ActionText, Object.assign({ textColor: getRoleNightActionColor(action.role) }, { children: [_jsxs("span", { children: [getRoleNightActionName(action.role), ":"] }), _jsx(Delimiter, { right: "8px" }), getPlayerName(action.targetId)] }))] }), _jsx(Delimiter, { top: "17px" }), _jsx(UnderLine, { theme: { borderColor: '#517573' } })] }, action.role)))] }));
                            })] })), _jsx(Delimiter, { top: "40px" }), _jsx(ButtonContainer, { children: _jsx(Button, Object.assign({ variant: "outlined", disabled: hasActiveRole, onClick: () => changePhase(matchId) }, { children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u043D\u043E\u0447\u044C" })) })] })) })));
    }
    const onPlayerClickAction = null;
    const gameButtonState = {
        text: '',
        visible: false,
        onClick: () => null,
    };
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState, addOnComponent: (data) => NightActionsInfoModal(data) }));
}
